<template>
  <div>
    <div>
      <b-card class="card-statistics border border-secondary  ">
        <font
          size="5"
          color="##132c9b"
        >
          <span style="color:gray"><center>Cihaz Ekleme Paneli</center> </span>
        </font><hr>
        <div class="col-md-8 mx-auto">
          <div class="demo-inline-spacing">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
              pill
            >
              <feather-icon
                icon="RepeatIcon"
                class="mr-25"
              />

              Yenile
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="secondary"
              pill
            >
              <feather-icon
                icon="ChevronsDownIcon"
                class="mr-25"
              />
              Excele Aktar
            </b-button>
            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="warning"
              pill
            >
              <feather-icon
                icon="ChevronsUpIcon"
              />
              Veri Girişi
            </b-button>
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="secondary"
              pill
            >
              <feather-icon
                icon="CornerRightUpIcon"
              />
              Toplu OSOS Girişi
            </b-button>
          </div>
          <br>
        </div>
        <div>
          <b-form-select
            id="head"
            v-model="selected8"
            :options="options8"
            class="mb-1"
          >
            <b-form-select-option
              :value1="null"
              disabled
            >
              Hangi Enerji Birimine Cihaz Tanımlanacak?
            </b-form-select-option>
            <b-form-select-option value="yes">
              <b>Elektrik</b>
            </b-form-select-option>
            <b-form-select-option value="no">
              <center>Doğalgaz</center>
            </b-form-select-option>
            <b-form-select-option value="no">
              <b>Su</b>
            </b-form-select-option>
            <b-form-select-option value="no">
              <b>Güneş Enerji Sistemleri</b>
            </b-form-select-option>
          </b-form-select>
        </div>
        <div class="form-label-group">
          <b-input-group>
            <b-form-input
              id="head"
              type="text"
              placeholder="Tabloda Ara"
            />

          </b-input-group>
        </div>
        <br>
        <sayac-tablo
          v-if="true==false"
          class="table"
        />
        <b-table-simple
          hover
          small
          caption-top
          responsive
        >

          <b-thead head-variant="dark">

            <b-tr>
              <b-th>ID</b-th>
              <b-th>Sektör Adı</b-th>
              <b-th>Cihaz Seri No</b-th>
              <b-th>Cihaz Adı</b-th>
              <b-th>Cihaz Türü</b-th>
              <b-th>Modül Numarası</b-th>
              <b-th>Cihaz Modeli</b-th>
              <b-th>Cihaz Konumu</b-th>
              <b-th>İşlem</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="item,index in tableData"
              :key="index"
            >
              <b-td>{{ item.id }}</b-td>
              <b-td>{{ item.Sektör }}</b-td>
              <b-td>{{ item.seri }}</b-td>
              <b-td>{{ item.cihazAd }}</b-td>
              <b-td>{{ item.cihazModel }}</b-td>
              <b-td>{{ item.cihazTur }}</b-td>
              <b-td>{{ item.cihazKonum }}</b-td>
              <b-td>{{ item.tarih }}</b-td>
              <b-td>{{ item.islem }}</b-td>
            </b-tr>

          </b-tbody>
        </b-table-simple>
        <br>

        <br>
        <br>
        <b-col
          lg="8"
          md="3"
          class="yann"
        >
          <b-form-group
            label-for="item-name"
          >
            <b-form-input
              id="item-name"
              type="text"
              placeholder="Sektör Adını Giriniz"
            />
          </b-form-group>
        </b-col>
        <b-form
          ref="form"
          :style="{height: trHeight}"
          class="repeater-form"
          @submit.prevent="repeateAgain"
        >

          <!-- Row Loop -->
          <b-row
            v-for="(item, index) in items"
            :id="item.id"
            :key="item.id"
            ref="row"
            class="yann"
          >

            <!-- Item Name -->
            <b-col lg="4">
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  v-model="cihazNo"
                  type="text"
                  placeholder="Cihaz Seri No"
                />
              </b-form-group>
              <b-form-group

                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                  placeholder="Cihaz Adı"
                />
              </b-form-group>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                  placeholder="Cihaz Türü"
                />
              </b-form-group>
            </b-col>

            <!-- Cost -->

            <!-- Quantity -->
            <b-col md="4">
              <b-form-group
                label-for="quantity"
              >
                <b-form-input
                  id="quantity"
                  type="text"
                  placeholder="Modül Numarası "
                />
              </b-form-group>
              <b-form-group
                label-for="quantity"
              >
                <b-form-input
                  id="quantity"
                  type="text"
                  placeholder="Cihaz Modeli"
                />
              </b-form-group>
              <b-form-group
                label-for="quantitiy"
              >
                <b-form-input
                  id="quantity"
                  type="text"
                  placeholder="Cihaz Konumu"
                />
              </b-form-group>
            </b-col>

            <!-- Profession -->

            <!-- Remove Button -->
            <b-col
              lg="3"
              md="2"
              class="mb-50"
            >

              <b-card>

                <!-- Button: Send Invoice -->

                <!-- Button: DOwnload -->

                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="success"
                  class="mb-75"
                  block
                  @click="addData"
                >
                  <feather-icon
                    icon="CornerUpRightIcon"
                    class="mr-25"
                  />
                  Kaydet
                </b-button>

                <!-- Button: Print -->
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-popover.hover.top="'I am popover directive content!'"
                  variant="danger"
                  block
                  title="Popover Title"
                  @click="removeItem(index)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    class="mr-0"
                  />
                  Temizle
                </b-button>

              </b-card>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
          </b-row>

        </b-form>
        <b-button
          id="bbtn"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="secondary"
          class="mb-75"
          @click="repeateAgain"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-25"
          />
          Yeni Cihaz Ekle
        </b-button>
      </b-card></div>
  </div>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BRow, BCol, BButton, BCard, BFormSelect, BFormSelectOption, BTableSimple, BThead, BTh, BTd, BTr, BTbody,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import sayacTablo from './SayacTablo.vue'

export default {
  components: {
    BTableSimple,
    BThead,
    BTd,
    BTr,
    BTh,
    BTbody,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    sayacTablo,
    BCard,
    BFormSelect,
    BFormSelectOption,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      tableData: [],
      id: '4',
      cihazNo: '1',
      cihazAd: '',
      cihazModel: 'model',
      cihazTur: '2',
      cihazKonum: '3',
      tarih: '4',
      islem: '5',
      items: [{
        id: 1,
        selected: 'male',
        selected1: 'designer',
        prevHeight: 0,
      }],
      nextTodoId: 2,
    }
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    const tableData = JSON.parse(localStorage.getItem('table-data'))
    if (tableData) {
      this.tableData = tableData
    }
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    addData() {
      this.tableData.push({
        id: '1',
        cihazNo: this.cihazNo,
        sektör: this.sektör,
        cihazModel: this.cihazModel,
        cihazTur: '2',
        cihazKonum: '3',
        tarih: '4',
        islem: '5',
      })
      localStorage.setItem('table-data', JSON.stringify(this.tableData))
    },
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    alert1() {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('...... Seri Numaralı Cihaz Eklensin Mi?', {
          title: 'Cihaz Ekleme Onayı',
          size: 'bg',
          okVariant: 'success',
          okTitle: 'Onayla',
          cancelTitle: 'İptal',
          cancelVariant: 'danger',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          this.boxTwo = value
        })
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
<style>
#head{
  background-color: antiquewhite;
}
.table{
  background-color: rgb(194, 202, 199);
}
#bbtn{
  float: right;
  margin-right: 45rem;
}
.yann{
  text-align: center;
  margin-left: 5rem;
}
</style>
